import React, { useState } from 'react';
import axios from 'axios';
import {
  HiOutlineOfficeBuilding,
  HiOutlinePencil,
  HiOutlinePlus,
  HiOutlineTrash
} from 'react-icons/hi';
import { TbDoorEnter } from 'react-icons/tb';
import { HiOutlineLightBulb } from 'react-icons/hi';

const API_URL = '/api';

function ZoneModal({ zone, facilityId, token, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    zoneName: zone?.zoneName || '',
    zoneType: zone?.zoneType || 'hol_ic',
    description: zone?.description || '',
    automationEnabled: zone?.automation?.enabled || false,
    scheduleMode: zone?.automation?.scheduleMode || 'manual',
    sunriseOffset: zone?.automation?.sunriseOffset || 0,
    sunsetOffset: zone?.automation?.sunsetOffset || 0,
    timeSchedule: zone?.automation?.timeSchedule || []
  });

  const addTimeSchedule = () => {
    setFormData({
      ...formData,
      timeSchedule: [
        ...formData.timeSchedule,
        {
          time: '08:00',
          action: 'on',
          days: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']
        }
      ]
    });
  };

  const removeTimeSchedule = (index) => {
    const newSchedule = formData.timeSchedule.filter((_, i) => i !== index);
    setFormData({...formData, timeSchedule: newSchedule});
  };

  const updateTimeSchedule = (index, field, value) => {
    const newSchedule = [...formData.timeSchedule];
    newSchedule[index][field] = value;
    setFormData({...formData, timeSchedule: newSchedule});
  };

  const toggleDay = (index, day) => {
    const newSchedule = [...formData.timeSchedule];
    const days = newSchedule[index].days || [];
    
    if (days.includes(day)) {
      newSchedule[index].days = days.filter(d => d !== day);
    } else {
      newSchedule[index].days = [...days, day];
    }
    
    setFormData({...formData, timeSchedule: newSchedule});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = {
      facility: facilityId,
      zoneName: formData.zoneName,
      zoneType: formData.zoneType,
      description: formData.description,
      automation: {
        enabled: formData.automationEnabled,
        scheduleMode: formData.scheduleMode,
        sunriseOffset: parseInt(formData.sunriseOffset) || 0,
        sunsetOffset: parseInt(formData.sunsetOffset) || 0,
        timeSchedule: formData.timeSchedule
      }
    };

    try {
      if (zone) {
        await axios.put(`${API_URL}/zones/${zone._id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Bölüm güncellendi');
      } else {
        await axios.post(`${API_URL}/zones`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Bölüm eklendi');
      }
      onSuccess();
    } catch (err) {
      alert('Hata: ' + err.response?.data?.error);
    }
  };

  const dayNames = {
    mon: 'Pzt',
    tue: 'Sal',
    wed: 'Çar',
    thu: 'Per',
    fri: 'Cum',
    sat: 'Cmt',
    sun: 'Paz'
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <h3 style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
          {zone ? <HiOutlinePencil size={20} /> : <HiOutlinePlus size={20} />}
          {zone ? 'Bölüm Düzenle' : 'Yeni Bölüm Ekle'}
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>BÖLÜM ADI *</label>
            <input
              type="text"
              value={formData.zoneName}
              onChange={(e) => setFormData({...formData, zoneName: e.target.value})}
              placeholder="HOL15"
              required
            />
          </div>

          <div className="form-group">
            <label>BÖLÜM TİPİ *</label>
            <div className="zone-type-selector">
              <div
                className={`zone-type-btn ${formData.zoneType === 'hol_ic' ? 'active' : ''}`}
                onClick={() => setFormData({...formData, zoneType: 'hol_ic'})}
              >
                <div className="zone-type-icon">
                  <HiOutlineOfficeBuilding size={32} color={formData.zoneType === 'hol_ic' ? '#3B82F6' : '#888'} />
                </div>
                <div className="zone-type-name">HOL İÇ</div>
              </div>
              <div
                className={`zone-type-btn ${formData.zoneType === 'hol_dis' ? 'active' : ''}`}
                onClick={() => setFormData({...formData, zoneType: 'hol_dis'})}
              >
                <div className="zone-type-icon">
                  <TbDoorEnter size={32} color={formData.zoneType === 'hol_dis' ? '#10B981' : '#888'} />
                </div>
                <div className="zone-type-name">HOL DIŞ</div>
              </div>
              <div
                className={`zone-type-btn ${formData.zoneType === 'cevre_aydinlatma' ? 'active' : ''}`}
                onClick={() => setFormData({...formData, zoneType: 'cevre_aydinlatma'})}
              >
                <div className="zone-type-icon">
                  <HiOutlineLightBulb size={32} color={formData.zoneType === 'cevre_aydinlatma' ? '#F59E0B' : '#888'} />
                </div>
                <div className="zone-type-name">ÇEVRE AYDINLATMA</div>
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>AÇIKLAMA</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              rows="2"
            />
          </div>

          <div className="form-group">
            <label style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <input
                type="checkbox"
                checked={formData.automationEnabled}
                onChange={(e) => setFormData({...formData, automationEnabled: e.target.checked})}
              />
              OTOMASYON AKTİF
            </label>
          </div>

          {formData.automationEnabled && (
            <>
              <div className="form-group">
                <label>OTOMASYON MODU</label>
                <select
                  value={formData.scheduleMode}
                  onChange={(e) => setFormData({...formData, scheduleMode: e.target.value})}
                >
                  <option value="manual">Manuel</option>
                  <option value="time">Saat Bazlı</option>
                  <option value="sunrise_sunset">Gün Doğumu/Batımı</option>
                </select>
              </div>

              {formData.scheduleMode === 'time' && (
                <div className="form-group">
                  <label style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px'}}>
                    <span>ZAMAN PROGRAMI</span>
                    <button 
                      type="button" 
                      className="btn-add btn-small"
                      onClick={addTimeSchedule}
                    >
                      + Program Ekle
                    </button>
                  </label>
                  
                  <div className="schedule-list">
                    {formData.timeSchedule.map((schedule, index) => (
                      <div key={index} className="schedule-item">
                        <div style={{display: 'grid', gridTemplateColumns: '120px 100px 1fr auto', gap: '10px', alignItems: 'center'}}>
                          <input
                            type="time"
                            value={schedule.time}
                            onChange={(e) => updateTimeSchedule(index, 'time', e.target.value)}
                          />
                          
                          <select
                            value={schedule.action}
                            onChange={(e) => updateTimeSchedule(index, 'action', e.target.value)}
                          >
                            <option value="on">AÇ</option>
                            <option value="off">KAPAT</option>
                          </select>

                          <div style={{display: 'flex', gap: '5px', flexWrap: 'wrap'}}>
                            {Object.keys(dayNames).map(day => (
                              <button
                                key={day}
                                type="button"
                                className={`day-btn ${(schedule.days || []).includes(day) ? 'active' : ''}`}
                                onClick={() => toggleDay(index, day)}
                              >
                                {dayNames[day]}
                              </button>
                            ))}
                          </div>

                          <button
                            type="button"
                            className="btn-delete btn-small"
                            onClick={() => removeTimeSchedule(index)}
                          >
                            <HiOutlineTrash size={16} />
                          </button>
                        </div>
                      </div>
                    ))}
                    
                    {formData.timeSchedule.length === 0 && (
                      <div style={{textAlign: 'center', padding: '20px', color: '#666'}}>
                        Henüz zaman programı eklenmedi
                      </div>
                    )}
                  </div>
                </div>
              )}

              {formData.scheduleMode === 'sunrise_sunset' && (
                <div className="form-row">
                  <div className="form-group">
                    <label>GÜN DOĞUMU OFFSET (dakika)</label>
                    <input
                      type="number"
                      value={formData.sunriseOffset}
                      onChange={(e) => setFormData({...formData, sunriseOffset: e.target.value})}
                      placeholder="0"
                    />
                  </div>
                  <div className="form-group">
                    <label>GÜN BATIMI OFFSET (dakika)</label>
                    <input
                      type="number"
                      value={formData.sunsetOffset}
                      onChange={(e) => setFormData({...formData, sunsetOffset: e.target.value})}
                      placeholder="0"
                    />
                  </div>
                </div>
              )}
            </>
          )}

          <div className="modal-actions">
            <button type="submit" className="btn">
              {zone ? 'GÜNCELLE' : 'EKLE'}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              İPTAL
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ZoneModal;
